<template>
   <el-dialog
    :visible.sync="visible"
    :show-close="false"
    :close-on-click-modal="false"
    :append-to-body="true"
    width="1000px"
    class="default-dialog"
  >
   <div class="title">生成凭证模板</div>
   <div class="container">
     <div class="acc_flex_1">
        <div class="acc_flex">模板名称：<el-input placeholder="请输入" v-model="name" style="width:120px;" size="mini" :maxlength="20" :disabled="lockName"></el-input></div>
        <div class="acc_flex">凭证字：
            <el-select v-model="vocherWordId" style="width:100px;" size="mini">
                <el-option
                v-for="item in voucherWordList"
                :key="item.id"
                :label="item.certificateWord"
                :value="item.id"
                >
              </el-option>
            </el-select>
        </div>
     </div>
    <!-- <el-button size="mini" class="greenText" @click="add">添加数据</el-button> -->
    <publicTable :table="tableData" style="margin-top:20px;">
        <template #operation="{scope}" >
            <div >
                <i @click='addTableData(scope.$index)' class='el-icon-plus'></i>
                <br/>
                <i @click='delTableData(scope.$index)' class='el-icon-delete'></i>
            </div>
        </template>
        <!-- 摘要-->
        <template #summary="{scope}">
            <el-input placeholder="请输入" v-model="scope.row.summary"></el-input>
        </template>
        <!-- 会计科目-->
        <template #subjectName="{scope}">
            <el-select v-model="scope.row.subjectName" filterable >
                <el-option 
                v-for="item in subjectList"
                 :key="item.id"
                :label="item.name"
                :value="item.name">
                </el-option>
            </el-select>
        </template>
        <!-- 余额方向-->
        <template #creditDirection="{scope}">
            <el-select v-model="scope.row.creditDirection"  >
                <el-option 
                v-for="item in yeList"
                 :key="item.value"
                :label="item.name"
                :value="item.value">
                </el-option>
            </el-select>
        </template>
        <!-- 取值账期-->
        <template #invoiceValue="{scope}">
             <el-select v-model="scope.row.invoiceValue" @change="zqChange(scope.row)"  >
                <el-option 
                v-for="item in zqList"
                 :key="item.id"
                :label="item.desc"
                :value="item.type">
                </el-option>
            </el-select>
        </template>
        <!-- 取值项目-->
        <template #invoiceSubjectRule="{scope}">
             <el-select v-model="scope.row.invoiceSubjectRule"  v-if="IfSubject(scope.row)" filterable>
                <el-option 
                v-for="item in scope.row.invoiceValue==1?currentProject:prevProject"
                 :key="item.type"
                :label="item.desc"
                :value="item.type">
                </el-option>
            </el-select>
            <div v-else>
                无数据
            </div>
        </template>
    </publicTable>
   </div>
    <div class="footer acc_flex">
      <el-button size="small" @click="visible = false">取消</el-button>
      <el-button size="small" class="submit" @click="submit" >保存</el-button>
    </div>
   </el-dialog>
</template>

<script>
import publicTable from '@/components/publicTable'
import {findSalaryValueRange,findSalaryValueProject,salaryVoucherTemplateTask} from '@/api/index.js'
export default {
    components:{
        publicTable
    },
    data(){
        return {
            lockName:false,
            zqList:[],
            yeList:[
                {name:'借',value:'借'},
                {name:'贷',value:'贷'}
            ],
            tableData:{
                	border: true,				// 是否带有纵向边框
					stripe: true,				// 是否带有斑马纹
					loading: false,				// 是否显示加载动画
					hasSelect: false,			// 是否显示多选
					hasOperation: false,		// 是否有操作功能
					hasContextmenu: false,		// 是否有右键功能
					hasShowSummary: false,		// 是否显示合计行
					hasShowPagination: false,	// 是否显示分页
                    config:[
                        {
                            value:'operation',
                            show:'template',
                            width:20
                        },
                        {
                            label:'摘要',
                            value:'summary',
                            show: 'template'
                        },
                        {
                            label:'会计科目',
                            value:'subjectName',
                            show: 'template'
                        },
                        {
                            label:'余额方向',
                            value:'creditDirection',
                            show: 'template'
                        },
                        {
                            label:'取值账期',
                            value:'invoiceValue',
                            show: 'template'
                        },
                        {
                            label:'取值项目',
                            value:'invoiceSubjectRule',
                            show: 'template'
                        },
                    ],
                    data:[],
                    center: {
						textAlign: 'center',
						padding: '6px 0'
					},
            },
            vocherWordId:'',
            name:'',
            visible:false,
            currentProject:[],
            prevProject:[],
            voucherWordList:[],
            subjectList:[],
            rows:'',
        }
    },
    computed:{
    // 获取会计期间开始时间
     nowYearPeriod() {
			return JSON.parse(sessionStorage.getItem('accountInfo')).nowYearPeriod;
		},
    },
    methods:{
        IfSubject(row){
            // scope.row.invoiceValue==1?currentProject:prevProject"
            let key = false
            if(row.invoiceValue==1&&this.currentProject.length){
                key = true
            }
            if(row.invoiceValue==2&&this.prevProject.length){
                key = true
            }
            return key
        },
        addTableData(index){
            // this.tableData.data.push({subjectName:"",summary:"",creditDirection:"",invoiceValue:"",invoiceSubjectRule:""})
            this.tableData.data.splice(index+1,0,{subjectName:"",summary:"",creditDirection:"",invoiceValue:"",invoiceSubjectRule:""})
        },
        delTableData(index){
        if (this.tableData.data.length == 2) {
            this.$message.error('至少保留两条数据')
            return
        }
        this.tableData.data.splice(index, 1)
        },
        //获取科目
        findObject(){
            this.$http.post("subject/getAllSujectByContent", {}).then((res) => {
                if (res && res.data.code == "1") {
                    this.subjectList = res.data.data
                }
            });
        },
        /** 获取取值项目 */
        getProject(current,prev){
            findSalaryValueProject({type:current.type,yearPeriod:this.nowYearPeriod}).then(res=>{
                if(res.data.code==1){
                    this.currentProject = res.data.data
                }
            })
            findSalaryValueProject({type:prev.type,yearPeriod:this.nowYearPeriod}).then(res=>{
                if(res.data.code==1){
                   this.prevProject = res.data.data
                 }
            })
        },
        /** 获取账期 */
        getSalaryValueRange(){
            findSalaryValueRange().then(res=>{
                if(res.data.code==1){
                    let current = res.data.data.find(e=>e.desc=='本期')
                    let prev = res.data.data.find(e=>e.desc=='上期')
                    this.getProject(current,prev)
                    this.zqList = res.data.data
                }
            })
        },
        /** 切换账期时 获取取值项目list */
        zqChange(row){
            this.$set(row,'invoiceSubjectRule','')
            console.log(row)
        },
        /** 获取凭证字 */
        getVoucerWordlList() {
         this.$http.post("voucherWord/getVoucherWordList", {})
            .then((res) => {
                if (res && res.data.code == "1") {
                    this.voucherWordList = res.data.data.list;
                    this.voucher = this.voucherWordList.length?this.voucherWordList[0].id:''
                }
            }).catch((e) => {});
        }, 
        /** 验证 模板必填 */
        validData(list){
            let key = true
            const json = {
                creditDirection:'余额方向',
                summary:'摘要',
                subjectName:'会计科目',
                invoiceSubjectRule:'取值项目',
                invoiceValue:'取值账期'
            }
            if(!this.name){
                this.$message.error('请输入模板名称')
                return
            }
            if(!this.vocherWordId){
                this.$message.error('请选择凭证字')
                return
            }
            if(!list.length){
               this.$message.error('请添加表格数据')
               return
            }
            let errorIndex
            let row = list.find((e,i)=>{
                let key = this.IfSubject(e)
                if(!e.summary||!e.subjectName||!e.creditDirection||!e.invoiceValue||(!e.invoiceSubjectRule&&key)){
                    errorIndex = i+1
                    return e
                }
            })
            for(let i in row){
                if(!row[i]){
                    this.$message.error(`第${errorIndex}行数据请录入${json[i]}`)
                    return
                }
            }
            return key
        },
        submit(){
            let params = {
                name:this.name,
                vocherWordId:this.vocherWordId,
            }
            this.rows.id?params.id = this.rows.id:false
            let list  = this.tableData.data.map(e=>{
                return {
                    summary:e.summary,
                    subjectName:e.subjectName,
                    creditDirection:e.creditDirection,
                    invoiceValue:e.invoiceValue,
                    invoiceSubjectRule:e.invoiceSubjectRule
                }
            })
            params.invoiceVoucherAddendumTemList = list
            let key = this.validData(list)
            if(key){
                salaryVoucherTemplateTask(params).then(res=>{
                    if(res.data.code==1){
                        this.$message.success(res.data.msg)
                        this.$emit('refsh')
                        this.visible = false
                    }
                })
            }
        },
        openTask(type,row){
            this.visible = true
            this.getVoucerWordlList()
            this.getSalaryValueRange()
            this.findObject()
            if(type=='add'){
                this.name = ''
                this.rows = ''
                this.vocherWordId = ''
                this.tableData.data = [{subjectName:"",summary:"",creditDirection:"",invoiceValue:"",invoiceSubjectRule:""},{subjectName:"",summary:"",creditDirection:"",invoiceValue:"",invoiceSubjectRule:""}]
                this.lockName = false
            }
            if(type=='edit'){
              console.log(row)
              this.rows = row
              this.lockName = row.lockName==1?true:false
              this.name = row.name
              this.vocherWordId = row.vocherWordId
              this.tableData.data = this.$lodash.cloneDeep(row.invoiceVoucherAddendumTemList)
            }
        }
    },
};
</script>

<style lang="less" scoped>
    //   /deep/ .el-table__row {
    //     > th:first-child {
    //       border: 0 !important;
    //       border-right: 1px solid #EBEEF5 !important;
    //     }
    //     > th:not(:first-child) {
    //       border-top: 1px solid #EBEEF5 !important;
    //     }
    //   }
.el-icon-plus, .el-icon-delete {
   cursor: pointer;
}
.greenText {
  color: #fff;
  margin-top: 20px;
  cursor: pointer;
  background: #269D7B;
}
.title {
  margin-bottom: 30px;
  font-size: 24px;
  color: #333333;
  font-weight: 500;
  text-align: center;
}
.footer {
  margin-top: 44px;
  justify-content: center;
  /deep/ .el-button {
    width: 100px;
  }
  .submit {
    color: #fff;
    margin-left: 20px;
    background: #269D7B;
  }
}
/deep/ .el-dialog__header,
/deep/ .el-dialog__footer {
  display: none;
}
/deep/ .el-dialog__body {
  padding: 30px 40px;
}
</style>


// WEBPACK FOOTER //
// src/pages/salary/components/GenerateVoucher.vue